

export const runtimeIsProduction = process.env.NODE_ENV === 'production'